(function (win, $, eventhub) {
	'use strict';
	// "${pppParametersForm.isRebbilingOrUpdateMembership?string('true','false')}"
/* item:
* {
*   "id": 69814,
*   "name": "IvalogProd",
*   "quantity": 1,
*   "lineShipping": 0,
*   "lineHandling": 0,
*   "lineDiscount": 0,          // = totalDiscount of the product (without  "discount")
*   "lineDiscountPercent": 0,   // = ( lineDiscount/(amount*quantity) )* 100
*   "imageUrl": "http://xxx.xxx/picture.JPG",
*   "shortDescription": "",
*   "longDescription": "",
*   "amount": 7,
*   "shipping": 2,
*   "handling": 0,
*   "discount": 3,              // = itemDiscount + volumeDiscount + promotionDiscount + crossaleDiscount;
*   "discountPercent": 42.86,   // = (discount/amount) * 100
*   "promotion":null,           // "some string",
 *  "coupon":null,              // "some string",
 *   // "requestedTax": 0,  REMOVED
 *   // "taxAmount": 0,     REMOVED
*   "lineTax": 0,               // = (quantity * (amount + handling + shipping - discount) + lineHandling + lineShipping - lineDiscount) * lineTaxPercent/100;
*   "lineTaxPercent": 0,        //  (from Merchant)
*   "extendedAmount": 7
* }
*
* on item level:
* ===============
* lineShipping = total Shipping of the product
* lineHandling = total Handling ot the product
* lineDiscount = total Discount of the product + crossaleDiscount + volumeDiscount + Promotion discount
* lineDiscountPercents = ( lineDiscount/(amount*quantity) ) * 100
* shipping = item shipping for a signle item
* handling = item handling for a signle item
* discount = item discount for a signle item
*
* on total level:
* ===============
* shipping = lineShipping + itemShipping * quantity (for each product)
* handling = lineHandling + itemHandling * quantity (for each product)
* discount = lineDiscount + itemDiscount * quantity (for each product)
* orderDiscount - send by the merchant
* orderHandling - send by the merchant
* orderShipping - send by the merchant
* discountPercent - (all of the discounts/amount) *100
* tax        = the sum of item's lineTax
* taxPercent = ( tax/(amount + handling + shipping - discount) )* 100;
* orderTax   = ("всичко дължимо преди orderTax") * orderTaxPercent/100
* orderTaxPercent = tax_amount(sent by the merchant in the request)
*
* */
	var uid = 1;
	var pluginName = 'ProductList';
	var ghostClickElapsedTime = 50;
	var iScrollClassName = 'product_list_scroll';
	var constants = {
		id_prefix:{
			coupon          : "cupon_",
			item_quantity   : "item_quantity_",
			btn_quantity    : "btn_quantity_"
		},
		action : {
			apply_coupon       : 'applyCoupon',
			back_to_shop       : 'back_to_shop',
			changeQuantity     : 'changeQuantity',
			changeCurrency     : 'changeCurrency',
			removeFromCart     : 'removeFromCart',
			showVolumeDiscount : 'showVolumeDiscount',             // 'popUpVolumeDiscount',
			addCrossSale       : 'addCrossSale',
			makeUpSell         : 'makeUpSell'
		}
	};

	var default_row_header =
		'<tr class="<%- classPrefix%>_row header">' +
		'<% _.each(itemKeys , function(key){ %>' +
		'<td class="<%- key%>"><%= t(key)%></td>' +
		'<%});%>' +
		'</tr>';

	var default_row_content =
		'<tr class="<%- item.classPrefix%>_row <%-item.row_class%> <%if(!item.imageUrl){%> noImg<%} if (item.type && item.type === "Discount") {%> discountItem<%}%>" data-id="<%- item.id%>">' +
		'<% _.each(itemKeys , function( key){ %>' +
			'<td class="<%- key%>">' +
			'<%if(key === "imageUrl" && item[key] ){%>' +
				'<div class="logo"><img src="<%- item[key]%>" alt="<%- item.name%>" height="42" width="42"/></div> ' +
			'<%} else if(key === "showVolumeDiscount" && item[key] ){%>' +
				'<button type="button" class="showVolumeDiscount" data-action="showVolumeDiscount" data-id="<%- item.id%>" data-collection="<%- item.collection%>" ><%= t("discount_available")%></button>' +
			'<%} else if(key === "quantity" && item[key] ){%>' +
				'<%if(productOpts.useChangeQuantity && item.quantity_action){%>' +
				'<input type="text" id="<%- item.input_id%>" maxlength="7" value="<%- item.quantity%>" />' +
				'<button type="button" id="<%-item.btn_quantity_id%>"  data-action="<%- item.quantity_action%>" data-id="<%- item.id%>" data-collection="<%- item.collection%>" class="change_quantity_button" ><%= t("change_quantity")%></button>' +
				'<%}else{%> <%- item.quantity%> <%}%>' +
			'<%} else if(key === "action" && item[key] ){%>' +
				'<%if(item[key]!="removeFromCart" || item.isCrossSale){%>' +
				'<button type="button" class="btn" data-action="<%- item.action%>" data-id="<%- item.id%>" data-collection="<%- item.collection%>" ><%- t(item[key])%></button>' +
				'<%}%>' +
		'<%} else {%>' +
				'<%= item[key] %>' +
			'<%}%>' +
			'</td>' +
		'<%});%>' +
		'</tr>';
	var default_items_rendering_order = [
		'action', 'imageUrl', 'name', 'amount', 'quantity', 'extendedAmount'
		, 'shortDescription', 'longDescription'
		, 'discount', 'discountPercent', 'lineDiscount', 'lineDiscountPercent', 'bundle_discount'
		, 'newPrice', 'newLinePrice'
		, 'shipping', 'handling', "lineTax", "lineTaxPercent", 'lineShipping', 'lineHandling'
	];

	var defaults = {
		isRTL               : false,
		csTitle             : '',   // "${pppParametersForm.crossSellingTitle}",
		csDescription       : '',   // "${pppParametersForm.crossSellingDescription}",
		usTitle             : '',   //
		usDescription       : '',   //
		productOpts         : {
			useChangeQuantity        : true,
			buyProductBundleQuantity : false,
			showItemDiscount         : false, // true,
			isSubscriptionAction     : false,
			isOpenAmount             : false,
			isRebilling              : false
		},
		scroll_main: {
			isScrollEnabled  : true,
			showControls     : false,
			staticControls   : false,
			animationSpeed   : 250,
			scrollMargin     : 30,
			scrollerSettings : {
				className        : '.' + iScrollClassName,
				scrollX          : false,
				scrollY          : true,
				mouseWheel       : true,
				scrollbars       : true,
				tap              : true,
				shrinkScrollbars : 'scale'
			}
		},
		scroll_cs: {
			isScrollEnabled  : false,
			showControls     : false,
			staticControls   : false,
			animationSpeed   : 250,
			scrollMargin     : 20,
			scrollerSettings : {
				className        : '.' + iScrollClassName,
				scrollX          : true,
				scrollY          : false,
				mouseWheel       : true,
				scrollbars       : true,
				tap              : true,
				preventDefault   : false,
				shrinkScrollbars : 'scale'
			}
		},
		scroll_us: {
			isScrollEnabled  : false,
			showControls     : false,
			staticControls   : false,
			animationSpeed   : 250,
			scrollMargin     : 20,
			scrollerSettings : {
				className        : '.' + iScrollClassName,
				scrollX          : true,
				scrollY          : false,
				mouseWheel       : true,
				scrollbars       : true,
				tap              : true,
				preventDefault   : false,
				shrinkScrollbars : 'scale'
			}
		},
		to_be_formatted     : {
			items   : {"amount": 1, "shipping": 1, "handling": 1, "discount": 1, "lineShipping": 1, "lineHandling": 1, "lineDiscount": 1, "lineTax":1, "extendedAmount": 1},
			cs      : {"amount": 1, "shipping": 1, "handling": 1, "discount": 1, "lineShipping": 1, "lineHandling": 1, "lineDiscount": 1, "lineTax":1, "extendedAmount": 1},
			us      : {"amount": 1, "shipping": 1, "handling": 1, "discount": 1, "lineShipping": 1, "lineHandling": 1, "lineDiscount": 1, "lineTax":1, "extendedAmount": 1},
			summary : {"amount": 1, "shipping": 1, "handling": 1, "discount": 1, "orderShipping": 1, "orderHandling": 1, "orderDiscount": 1, "tax":1, "orderTax":1, "taxAmount": 1, 'consumptionTaxAmount': 1, 'shipping_and_handling':1, 'airlineBoardingFee': 1, 'discount_sum':1, 'tipAmount': 1}
		},
		classPrefix         : 'product',
		changedElementClass : 'changed',
		thousandsSeparator  : ' ',
		currencySeparator   : ' ',
		defaultRoundingScale: 2,
		// onClickSelector     : '',
		btnSelector         : 'button',

		// itemsWrapperSelector       : '', // '#items_info',        // if it's out of pluginWrapper
		totalsWrapperSelector    : '', // '#totals_info',        // if it's out of pluginWrapper
		upSellWrapperSelector    : '', // '#up_sell_info',       // if it's out of pluginWrapper
		crossSellWrapperSelector : '', // '#cross_sell_info',    // if it's out of pluginWrapper
		totals_header            : '',
		pluginWrapper            : _.template('<div class="product_list <%-isScrollable%> <%-iScrollClassName%>"></div>'),
		templates                : {
			items_wrapper: '<div id="items_info" class="order_info"><table><thead><%= items_header%></thead><tbody><%= items_content%></tbody></table></div>'
				, row_items_header : default_row_header
				, row_items_content: default_row_content
			, totals_wrapper: '<div id="totals_info" ><%= totals_header%></div>'
				, coupon_item: '<div class="<%- item.classPrefix%>_row <%- item.type%> ">' +
						'<label for="<%- item.input_id%>" class=""><%- t("have_promo_code")%></label>' +
						'<div class="input_wrapp">' +
							'<input type="text" maxlength="15" id="<%- item.input_id%>"  placeholder="" value="" class="">' +
							'<button type="button" class="btn" data-action="<%- item.action%>" data-id="<%- item.id%>" data-collection="<%- item.collection%>" ><%- t("apply")%></button>' +
						'</div>' +
					'</div>'
				, summary_wrapper: '<div class="order_total"><table><tbody><%= summary_content%></tbody></table></div>'
					, row_summary_content: '<%if((type != "total_airlineBoardingFee" && type != "total_tipAmount" && type != "total_consumptionTaxAmount") || value > 0.00){%>' +
							'<tr class="<%- classPrefix%>_row <%- type%>">' +
								'<td class="totalName"><%= t(type)%> </td>' +
								'<td class="totalPrice"><%=formatted_value%></td>' +
							'</tr>' +
						'<%}%>'
				, grand_total: '<div class="order_grand_total"><table><tbody>' +
					'<tr class="<%- grandTotal.classPrefix%>_row <%- grandTotal.type%>">' +
						'<td class="totalName"><%= t(grandTotal.type)%> </td>' +
						'<td class="totalPrice">' +
							'<div class="row total_amount_section">' +
								'<div class="amount-container">' +
									'<input type="text" id="item_amount_1" class="amount open_amount_input"  name="item_amount_1" value="<%- grandTotal.value%>" autocomplete="off" readonly="readonly">' +
								'</div>' +
								'<div id="amount_div" class="fixedAmount"><div id="currency_lbl" class="currencyLabel"><%=grandTotal.currency%></div></div>' +
						'<%if(productOpts.isOpenAmount){%>' +
								'<div id="item_amount_1_validation" class="validation_image fixedCurrency invalid_field"></div>' +
						'<%}%>' +
							'</div>' +
						'</td>' +
					'</tr>' +
					'</tbody></table></div>'
			, cs_wrapper: '<div id="cross_sell_info">' +
					'<h2><%= csTitle%></h2>' +
					'<p><%= csDescription%></p>' +
					'<table><thead><%= items_header%></thead><tbody class="<%- scroll_classes %>"><%= items_content%></tbody></table>' +
				'</div>'
				, row_cs_header  : default_row_header
				, row_cs_content : default_row_content
			, us_wrapper: '<div id="up_sell_info">' +
					'<h2><%= usTitle%></h2>' +
					'<p><%= usDescription%></p>' +
					'<table><thead><%= items_header%></thead><tbody class="<%- scroll_classes %>"><%= items_content%></tbody></table>' +
				'</div>'
				, row_us_header  : default_row_header
				, row_us_content : default_row_content
			, controlsTemplate_X: "<div class='iscroll-controls-horizontal'>" +
					"<button type='button' class='left'>Left</button>" +
					"<button type='button' class='right'>Right</button>" +
				"</div>"
			, controlsTemplate_Y: "<div class='iscroll-controls-vertical'>" +
					"<button type='button' class='up'>Up</button>" +
					"<button type='button' class='down'>Down</button>" +
				"</div>"
		},
		main_rendering_order    : ['items_wrapper', 'summary_wrapper', 'grand_total', 'cs_wrapper', 'us_wrapper'],
		totals_rendering_order  : [
			'discount_sum', 'discount', 'discountPercent', 'shipping', 'handling', 'airlineBoardingFee',
			"tax", "taxPercent", "orderTax", "orderTaxPercent", 'consumptionTaxAmount', 
			'taxAmount', 'amount',
			/*'shipping_and_handling', */'useCoupon', 'orderDiscount', 'orderHandling', 'orderShipping',
			'tipAmount'
		],
		items_rendering_order   : default_items_rendering_order,
		cs_rendering_order      : default_items_rendering_order,
		us_rendering_order      : default_items_rendering_order,
		compositeProperties : { ///***** You can add custom properties per collection HERE: *****/
			totals: {
				shipping_and_handling : ['shipping', 'handling' , 'orderShipping', 'orderHandling'],
				taxAmount             : ['tax', 'orderTax'],
				discount_sum          : ['discount', 'orderDiscount']
			}
			// , items:{ }
			// , "cs":{ }
			// , "us":{ }
		},
		getIntlNumberFormatter : false, // OR Function
		useFixedFraction:true,
		currencyMap     : {
			'eur' : '€', 'usd' : '$', 'gbp' : '£', 'yen' : '¥', 'ils' : '₪', 'inr' : '₹',
			'rub' : '₽', 'try' : '₺', 'cny' : '¥', 'krw' : '₩', 'zar' : 'R', 'brl' : 'R$'
		},
		getCurrencyFormatter    : function (currencyMap, currencySeparator) { return function (currency, value) { if (currency) {
			if (currencyMap[currency.toLowerCase()]){ return currencyMap[currency.toLowerCase()] + currencySeparator + value; }
			return value + " " + currency.toUpperCase();} };
		},
		getNumberFormatter   : function (thousandsSeparator) {
			return function (number, currency, roundingScale) {
				var str = parseFloat(number);
				return str.toFixed(roundingScale).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSeparator);
			};
		}
	};
	var _lastEventTimestamp;

	var handleClicks = function (mainElm, options, ctx) {
		mainElm.on('click tap', options.btnSelector, function (evt) {
			var currentTime = (new Date()).getTime();
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) { // ghost click events
				_lastEventTimestamp = currentTime;
				return true;
			}
			var uniqueId = $(evt.target).data('id');
			var action = $(evt.target).data('action');
			var collection = $(evt.target).data('collection');
			var isDisabled = $(evt.target).data('disabled');
			if( !(uniqueId && action && collection) ){
				return true;
			}
			var data = ctx[collection + "_data_formatted"][uniqueId];
			if(options.changedElementClass) {
				var classPrefix = data.classPrefix;
				var row = $(evt.target).closest('.' + classPrefix + '_row');
				$('.' + options.changedElementClass, mainElm).removeClass(options.changedElementClass);
				row.addClass(options.changedElementClass);
			}
			var data_to_send = {
				action      : action,
				uniqueId    : uniqueId,
				currentData : data
			};
			// console.log(' ==========>>>> ctx.items_data_formatted, action >>>', data, action);
			if (action === constants.action.changeQuantity) {
				var old_quantity = data.quantity;
				var new_quantity = $('#' + data.input_id).val(); // $('#item_quantity_' + uniqueId).val();
				if (old_quantity == new_quantity) {
					_lastEventTimestamp = currentTime;
					evt.preventDefault();
					return;
				} else if (!new_quantity || new_quantity == '0') {
					data_to_send.action = constants.action.removeFromCart;
				}
				data_to_send.new_quantity = new_quantity;
				data_to_send.old_quantity = old_quantity;
				ctx.items_data_formatted[uniqueId].quantity = new_quantity;
			}else if(action === constants.action.apply_coupon){
				var coupon_val = $('#' + data.input_id).val();
				data_to_send.couponVal = coupon_val || '';
				if (!coupon_val || coupon_val == "") {
					_lastEventTimestamp = currentTime;
					evt.preventDefault();
					return;
				}
			}
			// else if(action === constants.action.changeCurrency){
			// 	//TODO:
			// 	var newCurrency = $(this).val();
			// 	data_to_send.newCurrency = newCurrency;
			// }
			if(!isDisabled ){ // prevent btn double click
				// console.log('==========>>>> data_to_send >>>', data_to_send);
				eventhub.publish('productlist-action', [data_to_send]);
				if(action === constants.action.addCrossSale || action === constants.action.makeUpSell){
					$(evt.target).data('disabled', true);
				}
			}
			_lastEventTimestamp = currentTime;
			evt.preventDefault();
		});
	};

	function _getSelectedItems(selectedItems, options) {
		var retArr = [];
		var items = (selectedItems && selectedItems.items) || [];
		var crossSales = (selectedItems && selectedItems.crossSales) || [];
		_.each(items, function (obj) {
			var item = _.extend({}, obj);
			item.isCrossSale = 0;
			retArr.push(item);
		});
		_.each(crossSales, function (obj) {
			var item = _.extend({}, obj);
			item.isCrossSale = 1;
			retArr.push(item);
		});
		return retArr;
	}

	function _getItemsHTML(ctx, collectionName, currency, currencyRoundingScale, classPrefix, action) {
		var to_be_formatted = ctx.options.to_be_formatted[collectionName];
		var itemCollection = ctx.options[collectionName + '_data'];
		var productOpts = ctx.options.productOpts;
		var items_content = '';
		var item_index = 0;
		var compositeProperties = ctx.options.compositeProperties[collectionName] || {};
		_.each(itemCollection, function (item) {
			item_index++;
			var payload = {};
			payload.classPrefix = classPrefix;
			payload.row_class = (item_index % 2 == 0) ? 'even' : 'odd';
			item.quantity = item.quantity || 1;
			item.item_index = item_index;
			_.each(item, function (value, key, x) {
				var formatted_value = value;
				if(compositeProperties[key]){
					var sum = 0;
					var multiplier = Math.pow(10, currencyRoundingScale);
					_.each(compositeProperties[key], function (k, i) {
						sum += Math.round(parseFloat(ctx.options[collectionName + '_data'][k]) * multiplier);
					});
					value = sum / multiplier;
				}
				if (to_be_formatted[key]) {
					formatted_value = ctx.formatter.formatCurrency(value, currency, currencyRoundingScale, ctx.options.useFixedFraction);
				} else if (key == 'discountPercent' || key == 'lineDiscountPercent') {
					formatted_value = value + ' %';
				}
				payload[key] = formatted_value;
			});

			var bundle_discount = item['discount'] * item['quantity'] + (item['lineDiscount'] || 0);
			var newLinePrice = (item['amount'] - item['discount'])*item['quantity'] - (item['lineDiscount'] || 0);
			payload['newPrice'] = ctx.formatter.formatCurrency(item['amount'] - item['discount'], currency, currencyRoundingScale, ctx.options.useFixedFraction);
			payload['newLinePrice'] = ctx.formatter.formatCurrency(newLinePrice, currency, currencyRoundingScale, ctx.options.useFixedFraction);
			payload['bundle_discount'] = ctx.formatter.formatCurrency(bundle_discount, currency, currencyRoundingScale, ctx.options.useFixedFraction);
			payload['productOpts'] = productOpts;
			payload['rawData'] = item;
			payload['collection'] = collectionName;
			payload['action'] = action;
			if(collectionName == "items") {
				payload['action'] = (item.isCrossSale) ? action : null;         // "removeFromCart"
				payload['quantity_action'] = constants.action.changeQuantity;   // "changeQuantity";
				payload['input_id'] = constants.id_prefix.item_quantity + payload['id'];
				payload['btn_quantity_id'] = constants.id_prefix.btn_quantity + payload['id'];
			}
			ctx[collectionName + '_data_formatted'][item.id] = payload;
			items_content += _.template(ctx.options.templates['row_' + collectionName +'_content'])({
				item        : payload,
				productOpts : productOpts,
				itemKeys    : ctx.options[collectionName + '_rendering_order']
			});
		});
		return items_content;
	}

	function _calcTotalItemsWidth( $items ) {
		var totalItemsHolderWidth = 0;
		($items || []).each(function () {
			totalItemsHolderWidth += $(this).outerWidth(true);
		});
		return totalItemsHolderWidth;
	}

	function Plugin(element, opts) {
		this.$element = $(element);
		this.options = $.extend(true, {}, defaults, opts);
		var self = this;
		var replaceables = [
			'main_rendering_order', 'totals_rendering_order', 'currencyMap'
			, 'items_rendering_order', 'cs_rendering_order', 'us_rendering_order'
			// , 'to_be_formatted.items', 'to_be_formatted.cs', 'to_be_formatted.us', 'to_be_formatted.summary',
		];
		_.each(replaceables, function(prop){
			var propArr= prop.split('.');
			if(propArr.length === 2 && opts[propArr[0]] && opts[propArr[0]][propArr[1]]){
				self.options[propArr[0]][propArr[1]] = $.extend(true, {}, opts[propArr[0]][propArr[1]]);
			} else if(opts[prop]){
				self.options[prop] = $.extend(true, {}, opts[prop]);
			}
		});

		this.init();
	}

	Plugin.prototype.init = function () {
		this.iScroll = {};
		if (this.options.getIntlNumberFormatter && typeof this.options.getIntlNumberFormatter == 'function') {
			this.formatter = this.options.getIntlNumberFormatter();
		} else {
			var baseCurrencyFormatter = this.options.getCurrencyFormatter(this.options.currencyMap, this.options.currencySeparator);
			var baseNumberFormatter = this.options.getNumberFormatter(this.options.thousandsSeparator);
			this.formatter = {
				formatDecimal: baseNumberFormatter,
				formatCurrency: function adapter(amount, currency, roundingScale) {
					return baseCurrencyFormatter(currency, baseNumberFormatter(amount, currency, roundingScale));
				}
			}
		}

		this.options.scroll_main.uniqueIScrollClass = iScrollClassName + '_' + uid;
		this.options.scroll_main.isScrollable = (this.options.scroll_main.isScrollEnabled ? 'scrollable' : '' );
		this.options.scroll_main.elmSelector = [(this.options.scroll_main.isScrollEnabled ? '.scrollable' : '' ), ".", this.options.scroll_main.uniqueIScrollClass].join('');
		this.options.scroll_main.itemSelector = [this.options.scroll_main.elmSelector, " .", this.options.classPrefix, '_row'].join('');

		this.options.scroll_cs.uniqueIScrollClass = 'cs_' + iScrollClassName + '_' + uid;
		this.options.scroll_cs.isScrollable = (this.options.scroll_cs.isScrollEnabled ? 'scrollable-x' : '' );
		this.options.scroll_cs.elmSelector = [(this.options.scroll_cs.isScrollEnabled ? '.scrollable-x' : '' ), ".", this.options.scroll_cs.uniqueIScrollClass].join('');
		this.options.scroll_cs.itemSelector = [(this.options.crossSellWrapperSelector  || this.options.scroll_cs.elmSelector), " .", this.options.classPrefix, '_cs', '_row'].join('');

		this.options.scroll_us.uniqueIScrollClass = 'us_' + iScrollClassName + '_' + uid;
		this.options.scroll_us.isScrollable = (this.options.scroll_us.isScrollEnabled ? 'scrollable-x' : '' );
		this.options.scroll_us.elmSelector = [(this.options.scroll_us.isScrollEnabled ? '.scrollable-x' : '' ), ".", this.options.scroll_us.uniqueIScrollClass].join('');
		this.options.scroll_us.itemSelector = [(this.options.upSellWrapperSelector || this.options.scroll_us.elmSelector), " .", this.options.classPrefix, '_us', '_row'].join('');

		this.options.pluginWrapper = this.options.pluginWrapper({
			iScrollClassName : this.options.scroll_main.uniqueIScrollClass,
			isScrollable     : this.options.scroll_main.isScrollable
		});
		this.$pluginWrapper = $(this.options.pluginWrapper);
		this.$wrapper = $('<div></div>');
		this.$pluginWrapper.append(this.$wrapper);
		this.$element.append(this.$pluginWrapper);

		handleClicks(this.$wrapper, this.options, this);
		if (this.options.totalsWrapperSelector && $(this.options.totalsWrapperSelector).length) {
			handleClicks($(this.options.totalsWrapperSelector), this.options, this);
		}
		if (this.options.crossSellWrapperSelector && $(this.options.crossSellWrapperSelector).length) {
			handleClicks($(this.options.crossSellWrapperSelector), this.options, this);
		}
		if (this.options.upSellWrapperSelector && $(this.options.upSellWrapperSelector).length) {
			handleClicks($(this.options.upSellWrapperSelector), this.options, this);
		}

		$(window).resize(_.bind(function(){this.updateScroll(); this.setupControls();}, this));
		eventhub.subscribe('products-available', this.render, this);
		eventhub.subscribe('currencies-available', this.updateCurrencies, this);
	};

	Plugin.prototype.updateItems = function (data, currency, currencyRoundingScale) {
		var self = this;
		currency = currency || self.options.currency;
		currencyRoundingScale = isNaN(currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(currencyRoundingScale);
		var collectionName = "items";
		var classPrefix = self.options.classPrefix;
		self.options[collectionName + '_data'] = data || [];
		self[collectionName + '_data_formatted'] = {};
		var items_header = _.template(self.options.templates.row_items_header)({
			classPrefix : self.options.classPrefix,
			productOpts : self.options.productOpts,
			itemKeys    : self.options.items_rendering_order
		});
		var items_content = _getItemsHTML(self, collectionName, currency, currencyRoundingScale, classPrefix, constants.action.removeFromCart) ;

		var $html = $(_.template(self.options.templates.items_wrapper)({
			items_content : items_content,
			items_header  : items_header
		}));
		if (self.$items_wrapper && self.$items_wrapper.length) {
			self.$items_wrapper.replaceWith($html);
			self.$items_wrapper = $html;
		} else {
			self.$items_wrapper = $html;
			self.$wrapper.append(self.$items_wrapper);
		}
		this.updateScroll();
		this.setupControls();
	};

	Plugin.prototype.updateSummary = function (data, currency, currencyRoundingScale) {
		var self = this;
		currency = currency || self.options.currency;
		currencyRoundingScale = isNaN(currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(currencyRoundingScale);
		var to_be_formatted = self.options.to_be_formatted.summary;
		var collectionName = "summary";
		var classPrefix  =  self.options.classPrefix + '_smry';
		var summary_content = '';
		self.options.summary_data = data || {};
		self.summary_data_formatted = {};
		var compositeProperties = self.options.compositeProperties.totals; // e.g. { shipping_and_handling: ['shipping', 'handling'], taxAmount: ['tax', 'orderTax'] };
		_.each(self.options.totals_rendering_order, function (key, x) {
			var value = self.options.summary_data[key];
			if(compositeProperties[key]){
				var sum = 0;
				var multiplier = Math.pow(10, currencyRoundingScale);
				_.each(compositeProperties[key], function (k, i) {
					sum += Math.round(parseFloat(self.options.summary_data[k]) * multiplier);
				});
				value = sum / multiplier;
			}
			var formatted_value = value;
			if (to_be_formatted[key]) {
				formatted_value = self.formatter.formatCurrency(value, currency, currencyRoundingScale, self.options.useFixedFraction);
			} else if (key == 'discountPercent' || key == 'taxPercent' || key == 'orderTaxPercent') {
				formatted_value = value + ' %';
			}
			var payload = {
				type            : 'total_' + key,
				currency        : currency,
				value           : value,
				formatted_value : formatted_value,
				classPrefix     : classPrefix,
				collection      : collectionName
			};
			if(key == 'useCoupon'){
				payload['action']   = constants.action.apply_coupon;
				payload['input_id'] = constants.id_prefix.coupon + key;
				payload['id']       = key;
				self.summary_data_formatted[key] = payload;
				if(value){
					summary_content += _.template(self.options.templates.coupon_item)({item : payload});
				}
			} else {
				self.summary_data_formatted[key] = payload;
				summary_content += _.template(self.options.templates.row_summary_content)(payload);
			}
		});
		var $html = $(_.template(self.options.templates.summary_wrapper)({
			summary_content : summary_content
		}));
		if (self.$summary_wrapper && self.$summary_wrapper.length) {
			self.$summary_wrapper.replaceWith($html);
			self.$summary_wrapper = $html;
		} else {
			self.$summary_wrapper = $html;
			if (self.options.totalsWrapperSelector && $(self.options.totalsWrapperSelector).length) {
				$(self.options.totalsWrapperSelector).append(self.$summary_wrapper);
			} else if(self.$totals_wrapper && self.$totals_wrapper.length){
				self.$totals_wrapper.append(self.$summary_wrapper);
			} else {
				self.$totals_wrapper = $(_.template(self.options.templates.totals_wrapper)({totals_header : self.options.totals_header}));
				self.$totals_wrapper.append(self.$summary_wrapper);
				self.$wrapper.append(self.$totals_wrapper);
			}
		}
		this.updateScroll();
		this.setupControls();
	};

	Plugin.prototype.updateGT = function (data, currency, currencyRoundingScale) {
		var self = this;
		currency = currency || self.options.currency;
		currencyRoundingScale = isNaN(currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(currencyRoundingScale);
		var collectionName = "gt";
		var classPrefix  =  self.options.classPrefix + '_gt';
		self.options.gt_data = data || {};
		var value = self.options.gt_data['grandTotal'];
		var formatted_value = self.formatter.formatCurrency(value, currency, currencyRoundingScale, self.options.useFixedFraction);
		var grand_total_payload = {
			grandTotal : {
				type            : 'grandTotal',
				currency        : currency,
				value           : value,
				formatted_value : formatted_value,
				classPrefix     : classPrefix,
				collection      : collectionName
			},
			productOpts     : self.options.productOpts
		};
		self.gt_data_formatted = grand_total_payload.grandTotal;
		var $gt_html = $(_.template(self.options.templates.grand_total)(grand_total_payload));
		if (self.$grand_total && self.$grand_total.length) {
			self.$grand_total.replaceWith($gt_html);
			self.$grand_total = $gt_html;
		} else {
			self.$grand_total = $gt_html;
			if (self.options.totalsWrapperSelector && $(self.options.totalsWrapperSelector).length) {
				$(self.options.totalsWrapperSelector).append(self.$grand_total);
			} else if(self.$totals_wrapper && self.$totals_wrapper.length){
				self.$totals_wrapper.append(self.$grand_total);
			} else {
				self.$totals_wrapper = $(_.template(self.options.templates.totals_wrapper)({totals_header : self.options.totals_header}));
				self.$totals_wrapper.append(self.$grand_total);
				self.$wrapper.append(self.$totals_wrapper);
			}
		}
		this.updateScroll();
		this.setupControls();
	};

	Plugin.prototype.updateCrossSell = function (data, currency, currencyRoundingScale) {
		var self = this;
		currency = currency || self.options.currency;
		currencyRoundingScale = isNaN(currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(currencyRoundingScale);
		var collectionName = "cs";
		var classPrefix = self.options.classPrefix + '_cs';
		self.options[collectionName + '_data'] = data || [];
		self[collectionName + '_data_formatted'] = {};
		var mainPayload = {
			csTitle       : self.options.csTitle,
			csDescription : self.options.csDescription
		};
		var items_header = _.template(self.options.templates.row_cs_header)({
			classPrefix : classPrefix,
			productOpts : self.options.productOpts,
			itemKeys    : self.options.cs_rendering_order
		});

		var cross_sell_items_content = _getItemsHTML(self, collectionName, currency, currencyRoundingScale, classPrefix, constants.action.addCrossSale);

		mainPayload['items_header'] = cross_sell_items_content ? items_header : '';
		mainPayload['items_content'] = cross_sell_items_content;
		mainPayload['scroll_classes'] = (self.options.scroll_cs.isScrollable + ' ' + self.options.scroll_cs.uniqueIScrollClass );

		if (mainPayload.items_content) {
			var $html = $(_.template(self.options.templates.cs_wrapper)(mainPayload));
			if (self.$cross_sell_wrapper && self.$cross_sell_wrapper.length) {
				self.$cross_sell_wrapper.replaceWith($html);
				self.$cross_sell_wrapper = $html;
			} else {
				self.$cross_sell_wrapper = $html;
				if (self.options.crossSellWrapperSelector && $(self.options.crossSellWrapperSelector).length) {
					$(self.options.crossSellWrapperSelector).html(self.$cross_sell_wrapper);
				} else {
					self.$wrapper.append(self.$cross_sell_wrapper);
				}
			}
			this.updateScroll();
			this.setupControls();

        } else {
            if (self.$cross_sell_wrapper) {
                self.$cross_sell_wrapper.remove();
            }
		}
	};

	Plugin.prototype.updateUpSell = function (data, currency, currencyRoundingScale) {
		var self = this;
		currency = currency || self.options.currency;
		currencyRoundingScale = isNaN(currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(currencyRoundingScale);
		var collectionName = "us";
		var classPrefix = self.options.classPrefix + '_us';
		self.options[collectionName + '_data'] = data || [];
		self[collectionName + '_data_formatted'] = {};
		var mainPayload = {
			usTitle       : self.options.usTitle,
			usDescription : self.options.usDescription,
			classPrefix   : classPrefix
		};
		var items_header = _.template(self.options.templates.row_us_header)({
			classPrefix      : classPrefix,
			productOpts      : self.options.productOpts,
			itemKeys         : self.options.us_rendering_order
		});
		var up_sell_items_content = _getItemsHTML(self, collectionName, currency, currencyRoundingScale, classPrefix, constants.action.makeUpSell);

		mainPayload['items_header'] = up_sell_items_content ? items_header : '';
		mainPayload['items_content'] = up_sell_items_content;
		mainPayload['scroll_classes'] = (self.options.scroll_us.isScrollable + ' ' + self.options.scroll_us.uniqueIScrollClass );

		if ((mainPayload.items_content)) {
			var $html = $(_.template(self.options.templates.us_wrapper)(mainPayload));
			if (self.$up_sell_wrapper && self.$up_sell_wrapper.length) {
				self.$up_sell_wrapper.replaceWith($html);
				self.$up_sell_wrapper = $html;
			} else {
				self.$up_sell_wrapper = $html;
				if (self.options.upSellWrapperSelector && $(self.options.upSellWrapperSelector).length) {
					$(self.options.upSellWrapperSelector).html(self.$up_sell_wrapper);
				} else {
					self.$wrapper.append(self.$up_sell_wrapper);
				}
			}
			this.updateScroll();
			this.setupControls();
        } else {
            if (self.$up_sell_wrapper) {
                self.$up_sell_wrapper.remove();
            }
		}
	};

	Plugin.prototype.updateCurrencies = function (data) {
		// TODO:
	};

	Plugin.prototype.updateScroll = function (scroll_type) {
		var self = this;
		var fakeScrollObj = function (elm, opt) {
			this.isFake          = true;
			this.wrapper         = elm;
			this.refresh         = _.identity;
			this.scrollToElement = _.identity;
			this.scrollTo        = _.identity;
			this.destroy         = _.identity;
			this.scrollBy        = _.identity;
			this.on              = _.identity;
		};

		var scrollers = {"scroll_main":1, "scroll_cs":1, "scroll_us":1};
		if(scroll_type && scrollers[scroll_type]){
			scrollers = {};
			scrollers[scroll_type] = 1;
		}
		_.each(scrollers, function (v, key) {
			var scroller = self.iScroll[key];
			var element = $(self.options[key].elmSelector)[0];
			var $items = $(self.options[key].itemSelector);
			var $itemsHolder = $items.first().parent();
			if(element && $items.length && $itemsHolder.length) {
				var isVertical = self.options[key].scrollerSettings.scrollY;
				if (self.options[key].scrollerSettings.scrollX && $itemsHolder.length) {
					$itemsHolder.css('width',  _calcTotalItemsWidth($items) + 'px');
				}
				if (scroller ) {
					scroller.destroy();
				}
				$('.iScrollLoneScrollbar', self.options[key].elmSelector).remove();
				if (self.options[key].isScrollEnabled && self.options[key].uniqueIScrollClass){
					self.iScroll[key] = new IScroll(element, self.options[key].scrollerSettings);
					scroller = self.iScroll[key];
					var needScroll = isVertical ? scroller.scrollerHeight > scroller.wrapperHeight : scroller.scrollerWidth > scroller.wrapperWidth;
					if (needScroll) {
						$('.iScrollLoneScrollbar', self.options[key].elmSelector).show();
					} else {
						$('.iScrollLoneScrollbar', self.options[key].elmSelector).hide();
					}
				} else if (!self.iScroll[key]) {
					self.iScroll[key] = new fakeScrollObj(element, self.options[key].scrollerSettings);
				}
			}
		});
	};

	Plugin.prototype.render = function (data) {
		var self = this;
		var currency = data.currency;
		var roundingScale = data.roundingScale;
		var structure = {
			items_wrapper   : 'Items',      //
			summary_wrapper : 'Summary',    //
			cs_wrapper      : 'CrossSell',  //
			us_wrapper      : 'UpSell',     //
			grand_total     : 'GT'          //
		};
		if (data['selectedItems']) {
			data.itemsData = _getSelectedItems(data['selectedItems']);
		}

		_.each(self.options.main_rendering_order, function (key) {
			var payload = data[(structure[key] || '').toLowerCase() + 'Data'] || {};
			if (key == "grand_total") {
				if (data.skipGT) {
					return;
				} else {
					payload = {
						grandTotal : data.summaryData['extendedAmount']
					};
				}
			}
			self['update' + structure[key]](payload, currency, roundingScale);
		});
		eventhub.publish('app.event.productlist.postRender', [{'skipGT' : !!data.skipGT}]);
	};

	function _showHideControls (scroll) {
		var dimension = scroll.hasHorizontalScroll ? 'Width' : 'Height';
		var $parent = $(scroll.wrapper).parent();
		scroll.refresh();
		if ( !scroll.isFake
			&& (scroll.hasHorizontalScroll || scroll.hasVerticalScroll)
			&& (scroll["scroller" + dimension] > scroll["wrapper" + dimension])
		) {
			$(scroll.controlsWrapperSelector, $parent).show();
			if (scroll.staticControls) {
				$parent.addClass('iscroll-controls-static');
			}
		} else {
			$(scroll.controlsWrapperSelector, $parent).hide();
			$parent.removeClass('iscroll-controls-static');
		}
	}

	function _buttonsState( scroll ) {
		if((scroll.hasHorizontalScroll || scroll.hasVerticalScroll) &&  scroll.arrows) {
			var axis = scroll.hasHorizontalScroll ? 'x' : 'y';
			var maxScroll = 'maxScroll' + axis.toUpperCase();
			var $parent = $(scroll.wrapper).parent();
			var arrow =  scroll.arrows;
			if (scroll[axis] == 0) {
				$(arrow[0], $parent).attr('disabled', true);
				$(arrow[1], $parent).attr('disabled', false);
			}
			if (scroll[axis] > scroll[maxScroll] && scroll[axis] != 0) {
				$(arrow[0], $parent).attr('disabled', false);
				$(arrow[1], $parent).attr('disabled', false);
			}
			if (scroll[axis] == scroll[maxScroll]) {
				$(arrow[0], $parent).attr('disabled', false);
				$(arrow[1], $parent).attr('disabled', true);
			}
		}
	}

	Plugin.prototype.setupControls = function(scroll_type) {
		var self = this;
		var scrollControlsWrapperClass = {
			x: 'iscroll-controls-horizontal',
			y: 'iscroll-controls-vertical'
		};
		var arrows      = {x: ['.left', '.right'], y: ['.up', '.down']};
		var dimensions  = {x: 'Width', y: 'Height'};
		var scrollers   = {"scroll_main":1, "scroll_cs":1, "scroll_us":1};
		if(scroll_type && scrollers[scroll_type]){
			scrollers = {};
			scrollers[scroll_type] = 1;
		}

		_.each(scrollers, function (v, key) {
			var opt     = self.options[key];
			var scroll  = self.iScroll[key];
			if(scroll && opt.isScrollEnabled && opt.showControls ) {
				var wrapper = scroll.wrapper;
				var $parent = $(wrapper).parent();
				var axis = opt.scrollerSettings.scrollX ? 'x' : 'y';

				scroll.type = key;
				scroll.controlsWrapperSelector = '.' + scrollControlsWrapperClass[axis];
				scroll.staticControls = opt.staticControls;

				if ( !scroll.isFake && (scroll.hasHorizontalScroll || scroll.hasVerticalScroll) ) {
					var arrow = arrows[axis];
					var dimension = dimensions[axis];
					var easing = IScroll.utils.ease.quadratic;
					var margin = self.options[key].scrollMargin || 0;
					var duration = self.options[key].animationSpeed || 1000;
					scroll.arrows = arrow;
					if (!$.data($parent[0], 'scroll_' + key + '_arrows')) {
						$.data($parent[0], 'scroll_' + key + '_arrows', arrows[axis]);

						$parent.on('click', arrow[0], function () {
							var coordinates = {x : 0, y : 0};
							var scroll = self.iScroll[key];

							if (!scroll.isFake) {
								if (scroll[axis] + scroll["wrapper" + dimension] >= 0) {
									scroll.scrollTo(0, 0, duration, easing);
									$(arrow[0], $parent).attr('disabled', true);
								} else {
									coordinates[axis] = scroll["wrapper" + dimension] - margin;
									scroll.scrollBy(coordinates.x, coordinates.y, duration, easing);
								}
								$(arrow[1], $parent).attr('disabled', false);
							}
						});

						$parent.on('click', arrow[1], function () {
							var coordinates = {x : 0, y : 0};
							var scroll = self.iScroll[key];
							if (!scroll.isFake) {
								var maxScroll = 'maxScroll' + axis.toUpperCase();
								if (scroll[axis] - scroll["wrapper" + dimension] <= scroll[maxScroll]) {
									coordinates[axis] = scroll[maxScroll];
									scroll.scrollTo(coordinates.x, coordinates.y, duration, easing);
									$(arrow[1], $parent).attr('disabled', true);
								} else {
									coordinates[axis] = -scroll["wrapper" + dimension] + margin;
									scroll.scrollBy(coordinates.x, coordinates.y, duration, easing);
								}
								$(arrow[0], $parent).attr('disabled', false);
							}
						});
					}
					if (!scroll.scrollEndHandled) {
						scroll.on('scrollEnd', function () {
							_buttonsState(scroll);
						});
						scroll.scrollEndHandled = true;
					}
					if (!$(scroll.controlsWrapperSelector, $parent).length) {
						var controlsTplTxt = self.options.templates["controlsTemplate_" + axis.toUpperCase()];
						var controls = _.template(controlsTplTxt)();
						$parent.append(controls);
						if (scroll.staticControls) {
							$parent.addClass('iscroll-controls-static');
						}
					}
				}
				_showHideControls(scroll);
				_buttonsState(scroll);
			} // end IF ( opt.showControls)
		});
	};


	$.fn[pluginName] = function (options) {
		return this.each(function () {
			var _pluginName = 'plugin_' + pluginName;
			if (!$.data(this, _pluginName)) {
				$.data(this, _pluginName, new Plugin(this, options));
				uid += 1;
			}
		});
	}
}(window, $, pubsub));